import React from 'react';
export function ChatIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M8 9a1 1 0 100 2 1 1 0 000-2zM12 9a1 1 0 100 2 1 1 0 000-2zM15 10a1 1 0 112 0 1 1 0 01-2 0z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 18a2 2 0 002-2V4a2 2 0 00-2-2H3a2 2 0 00-2 2v12a2 2 0 002 2h9l1.447 2.894A2 2 0 0015.237 22H18v-4h3zm0-14H3v12h10.236l2 4H16v-4h5V4z"
  }));
}